class Recipe {
    constructor() {
        this.addToggleEvent();
        this.addPrintEvent();
        this.addTabEvent();

        document
            .querySelectorAll(".recipe-block__section-wrapper")
            .forEach((element) => {
                element.classList.remove("recipe-block--open");
            });
    }

    /**
     * Add a toggleMenu event to each NodeList element provided.
     * @param triggerName
     */
    addToggleEvent() {
        const recipeTriggerNodes = document.querySelectorAll(
            "[data-toggle-recipe]",
        );

        if (recipeTriggerNodes.length > 0) {
            [...Array.from(recipeTriggerNodes)].forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();

                    const target = e.currentTarget as HTMLElement;

                    const id = target.getAttribute("data-toggle-recipe");
                    const recipes = document.querySelectorAll(
                        '[data-recipe="' + id + '"]',
                    );
                    [...Array.from(recipes)].forEach((recipe) => {
                        recipe.classList.toggle("recipe-block--open");
                    });
                });
            });
        }
    }

    /**
     * Print click
     */
    addPrintEvent() {
        const printLinks = document.querySelectorAll("[data-print]");
        if (printLinks.length > 0) {
            [...Array.from(printLinks)].forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();
                    const target = e.currentTarget as HTMLElement;
                    const id = target.getAttribute("data-print");
                    const content = document.getElementById(
                        "recipe-print-" + id,
                    );

                    const isIFrame = (
                        input: HTMLElement | null,
                    ): input is HTMLIFrameElement =>
                        input !== null && input.tagName === "IFRAME";

                    const frame = document.getElementById("ifmcontentstoprint");
                    if (isIFrame(frame) && frame.contentWindow) {
                        const print = frame.contentWindow;
                        print.document.open();
                        print.document.write(content?.innerHTML || "");
                        print.document.close();
                        print.focus();
                        print.print();
                    }
                });
            });
        }
    }

    addTabEvent() {
        const tabTriggerNodes = document.querySelectorAll("[data-toggle-tab]");
        if (tabTriggerNodes.length > 0) {
            [...Array.from(tabTriggerNodes)].forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();
                    const target = e.currentTarget as HTMLElement;
                    const id = target.getAttribute("data-tab-recipe");
                    const index = target.getAttribute("data-tab-index");
                    const tabs = document.querySelectorAll(
                        '[data-recipe="' + id + '"] [data-tab-recipe]',
                    );
                    const activeTabs = document.querySelectorAll(
                        '[data-recipe="' +
                            id +
                            '"] [data-tab-index="' +
                            index +
                            '"]',
                    );
                    tabs.forEach((el) => {
                        el.classList.remove("active");
                    });
                    activeTabs.forEach((el) => {
                        el.classList.add("active");
                    });
                });
            });
        }
    }
}

export default Recipe;
